import { render } from "./NewCustomersThisMonth.vue?vue&type=template&id=254f4f59"
import script from "./NewCustomersThisMonth.vue?vue&type=script&lang=js"
export * from "./NewCustomersThisMonth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__